import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Api } from 'further-types/allocations';
import { api } from 'lib/httpClient';

async function fetchAllocations({ queryKey }) {
  const [, params] = queryKey;
  const { data } = await api.get(`allocations`, {
    params,
  });

  return data.data;
}

export function useAllocations({
  params,
  enabled = true,
}: {
  params: Api.GetAllocationsQueryParams;
  enabled?: boolean;
}) {
  return useQuery<Api.ListAllocationsResponse>({
    queryKey: ['allocations', { ...params }],
    queryFn: fetchAllocations,
    placeholderData: keepPreviousData,
    staleTime: 10 * 60 * 1000,
    enabled,
  });
}
